const navMain = {
  systems: 'Solutions',
  aboutUs: 'About Us',
  blog: 'Blog',
  career: 'Career',
  contact: 'Contacts',
  bpla: 'UAV',
  bpak: 'UAS',
  education: 'UAV OPERATOR TRAINING',
}
export default navMain
